import ProposalClientTeamView from "work/proposals/_views/_shared/proposal-client-team-view";
import type { RemoveFromWork } from "work/work-agreements/teams/_views/remove-from-work-row-actions";
import WorkAgreement from "work/work-agreements/work-agreement";

type ClientTeamTabProps = {
  workAgreement: WorkAgreement;
  /** The client team leader's removal of a member from running work (#6070), when the reader is them. */
  removeFromWork?: RemoveFromWork;
};

/**
 * Displays the client participant roster captured by the hired work agreement. Roster management
 * remains on the active proposal while it is being negotiated; once the work runs, the client team
 * leader may only take somebody off it (#6070).
 */
export default function ClientTeamTab({ workAgreement, removeFromWork }: Readonly<ClientTeamTabProps>) {
  return <ProposalClientTeamView clientTeam={workAgreement.clientTeam ?? null} removeFromWork={removeFromWork} />;
}
